<template>
  <div v-if="!isLoading && list.length !== 0">
    <div style="display: flex; gap: 2rem; max-width: 490px; margin-top: 1rem;">
      <SelectJudicialStatus
        style="max-width: 235px;"
        v-model="judicialStatusInBatch"
      />
      <b-overlay
        :show="busy"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="secondary"
        class="d-inline-block"
      >
        <b-button
          :disabled="!selectInvoiceInBatch.length"
          @click="() => setJudicialStatusInBatch()"
          style="width: 100%;"
        >
          Atualizar em lote
        </b-button>
      </b-overlay>
    </div>
    <div class="d-flex justify-content-between flex-column">
      <Table style="margin-top: 1rem;" class="overdue-invoice-table">
        <TableHeader>
          <TableRow>
            <TableHead
              v-for="(overdueInvoiceCol, index) of overdueInvoiceColumns"
              :key="`${overdueInvoiceCol}_${index}`"
            >
              <ColumnHeader
                :sort="overdueInvoiceCol.sort"
                :somatory="overdueInvoiceCol.somatory"
                :columnName="overdueInvoiceCol.name"
                :columnKey="overdueInvoiceCol.key"
                :columnType="overdueInvoiceCol.columnType"
                :currentColumnFiltered="currentColumnFiltered"
                :sortDirection="sortDirection"
                :dataList="list"
                v-on:sortListByKey="sortListByKey(overdueInvoiceCol.key)"
              />
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow v-for="(item, index) of list" :key="`${item}_${index}`">
            <TableCell style="min-width: 95px;">
              <b-form-checkbox
                @change="value => setInvoiceInBatch(value, item.id)"
                size="sm"
              />
            </TableCell>
            <TableCell style="min-width: 95px;">
              {{ item.installationNumber }}
            </TableCell>
            <TableCell style="min-width: 305px;">
              <RenderNameColumnValue :name="item.name" />
            </TableCell>
            <TableCell style="text-align: right; min-width: 100px;">
              <RenderMoneyColumnValue :value="item.boletoVeins" />
            </TableCell>
            <TableCell style="text-align: right; min-width: 100px;">
              <RenderDateColumnValue :value="item.dueDate" />
            </TableCell>
            <TableCell>
              <RenderDateColumnValue
                :value="item.referenceDate"
                formatType="ABBREVIATEDMONTH/YYYY"
              />
            </TableCell>
            <TableCell style="text-align: right;">
              <span :style="setColor(item.delayedDays)">
                {{ item.delayedDays }}
              </span>
            </TableCell>
            <TableCell>
              <RenderInstallationStatusColumnValue
                :value="item.installationStatus"
              />
            </TableCell>
            <TableCell>
              <DownloadInvoiceButton :invoice="item" />
            </TableCell>
            <TableCell>
              <RenderDateColumnValue :value="item.fieldUpdateDate" />
            </TableCell>
            <TableCell :style="setDayCountColor(item.fieldUpdateDateDayCount)">
              {{ item.fieldUpdateDateDayCount }}
            </TableCell>
            <TableCell>
              <SelectJudicialStatus
                v-model="item.judicialStatus"
                @input="changeInvoiceJudicialStatus(item)"
              />
            </TableCell>
            <TableCell>
              <RenderPhoneColumnValue :phoneNumber="item.phone" />
            </TableCell>
            <TableCell>
              <b-form-datepicker
                placeholder="Data"
                v-model="item.dateToPaid"
                style="width: 150px; height: 30px; position: initial !important;"
                :date-format-options="{
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                }"
                locale="pt-BR"
                @input="setDateToPaid(item.dateToPaid, item.id)"
              />
            </TableCell>
            <TableCell>
              {{ item.responsible }}
            </TableCell>
            <TableCell>
              <RenderNameColumnValue
                v-if="item.accountManagerName"
                :name="item.accountManagerName"
              />
            </TableCell>
            <TableCell>
              <div style="display: flex; gap: 0.2rem;">
                <b-overlay
                  :show="busyButton"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="outline-primary"
                  class="d-inline-block"
                >
                  <BaseButtonComponent
                    style="padding: 1px 12px;"
                    @click="recordObservation(item)"
                    :disabled="!item.observation"
                    variant="tertiary-action"
                  >
                    Gravar
                  </BaseButtonComponent>
                </b-overlay>

                <b-form-textarea
                  id="textarea"
                  debounce="1000"
                  v-model="item.observation"
                  placeholder="Observação"
                  rows="3"
                  max-rows="6"
                  style="border-radius: 4px; outline: none; border: 1px solid grey; width: 244px; height: 30px;"
                >
                  {{ item.observation }}
                </b-form-textarea>
              </div>
            </TableCell>
            <TableCell>
              <b-form-checkbox
                :checked="Boolean(item.isSentToSerasa)"
                v-model="item.isSentToSerasa"
                :value="1"
                :unchecked-value="0"
                @change="
                  setIsSentToSerasa(Boolean(item.isSentToSerasa), item.id)
                "
              />
            </TableCell>
            <TableCell>
              <b-form-checkbox
                :checked="Boolean(item.isSentToProtest)"
                v-model="item.isSentToProtest"
                :value="1"
                :unchecked-value="0"
                @change="
                  setIsSentToProtest(Boolean(item.isSentToProtest), item.id)
                "
              />
            </TableCell>
            <TableCell>
              <b-form-checkbox
                :checked="Boolean(item.isSentToSmallClaims)"
                v-model="item.isSentToSmallClaims"
                :value="1"
                :unchecked-value="0"
                @change="
                  setIsSentToSmallClaims(
                    Boolean(item.isSentToSmallClaims),
                    item.id,
                  )
                "
              />
            </TableCell>
            <TableCell>
              <b-form-checkbox
                :checked="Boolean(item.isSentToFriendlyNotify)"
                v-model="item.isSentToFriendlyNotify"
                :value="1"
                :unchecked-value="0"
                @change="
                  setIsSentToFriendlyNotify(
                    Boolean(item.isSentToFriendlyNotify),
                    item.id,
                  )
                "
              />
            </TableCell>
            <TableCell>
              <b-form-checkbox
                :checked="Boolean(item.isSentToExtrajudicial)"
                v-model="item.isSentToExtrajudicial"
                :value="1"
                :unchecked-value="0"
                @change="
                  setIsSentToExtrajudicial(
                    Boolean(item.isSentToExtrajudicial),
                    item.id,
                  )
                "
              />
            </TableCell>
            <TableCell>
              <div style="display: flex; gap: 0.2rem;">
                <SendEmailInvoiceButton
                  :month="item.month"
                  :year="item.year"
                  :installation-number="item.installationNumber"
                />
                <SendHsmInvoiceButton
                  :month="item.month"
                  :year="item.year"
                  :installation-number="item.installationNumber"
                />
              </div>
            </TableCell>
            <TableCell>
              <MarkInvoiceToPaidButton
                :invoice="item"
                @reload="removeOverdueInvoiceToList"
              />
            </TableCell>
            <TableCell>
              <RenderNameColumnValue :name="item.nameTrader || ''" />
            </TableCell>
            <TableCell style="text-align: right;">
              <RenderMoneyColumnValue :value="item.consumerEconomy || 0" />
            </TableCell>
            <TableCell style="text-align: right;">
              <RenderKwhColumnValue :value="item.totalConsumption || 0" />
            </TableCell>
            <TableCell style="text-align: right;">
              <RenderKwhColumnValue :value="item.compensatedEnergy || 0" />
            </TableCell>
            <TableCell style="text-align: right;">
              <RenderKwhColumnValue :value="item.accumulatedBalance || 0" />
            </TableCell>
            <TableCell>
              <RenderSocialNumberColumnValue
                :social-number="item.socialNumber"
              />
            </TableCell>
            <TableCell>
              {{ item.distributorName }}
            </TableCell>
            <TableCell>
              {{ item.state }}
            </TableCell>
            <TableCell>
              {{ item.city }}
            </TableCell>
            <TableCell>
              {{
                item.lineTwo
                  ? `${item.address}, ${item.number}, ${item.lineTwo}, ${item.district}`
                  : `${item.address}, ${item.number}, ${item.district}`
              }}
            </TableCell>
            <TableCell>
              <RenderZipCodeColumnValue :zip-code="item.zipCode" />
            </TableCell>
            <TableCell>
              {{ item.email }}
            </TableCell>
            <TableCell style="text-align: right;">
              <RenderDateColumnValue :value="item.userCreatedAt" />
            </TableCell>
            <TableCell>
              {{ item.linhaDigitavel }}
            </TableCell>
            <TableCell>
              {{ item.erpId }}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  </div>
</template>

<script>
/// <reference path="../../types/index.js" />

import {
  RenderSocialNumberColumnValue,
  RenderZipCodeColumnValue,
  RenderKwhColumnValue,
  RenderDateColumnValue,
  RenderNameColumnValue,
  RenderMoneyColumnValue,
  RenderPhoneColumnValue,
  RenderInstallationStatusColumnValue,
} from '../../../../ui/render';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../ui/table';
import { setDelayedDaysColor } from '../../utils';
import {
  SendEmailInvoiceButton,
  SendHsmInvoiceButton,
  DownloadInvoiceButton,
  MarkInvoiceToPaidButton,
  SelectTicketCollector,
  SelectJudicialStatus,
} from '../index.js';
import { defineArrowDirection, sortByProperty } from '../../../../utils';
import { ColumnHeader } from '../../../../ui/column-header';
import { JUDICIAL_STATUS } from '../../constants';
import { Api } from '../../../../vue/api';
import { Auth } from '../../../../vue/auth';
import { BaseButtonComponent } from '../../../../ui/buttons';
const API = new Api();

export default {
  components: {
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    ColumnHeader,
    SendHsmInvoiceButton,
    SelectJudicialStatus,
    RenderKwhColumnValue,
    SelectTicketCollector,
    DownloadInvoiceButton,
    RenderNameColumnValue,
    RenderDateColumnValue,
    SendEmailInvoiceButton,
    RenderMoneyColumnValue,
    RenderPhoneColumnValue,
    MarkInvoiceToPaidButton,
    RenderZipCodeColumnValue,
    RenderSocialNumberColumnValue,
    RenderInstallationStatusColumnValue,
    BaseButtonComponent,
  },
  props: {
    /**
     * Lista de Faturas Atrasadas
     * @default []
     * @type {OverdueInvoice[]}
     */
    list: {
      default: [],
      required: true,
      type: Array,
    },
    isLoading: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      userData: {},
      judicialStatusInBatch: null,
      selectInvoiceInBatch: [],
      overdueInvoiceColumns: [
        {
          name: '#',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Instalação',
          key: 'installationNumber',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Consumidor',
          key: 'name',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Boleto Veins',
          key: 'boletoVeins',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Vencimento',
          key: 'dueDate',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Período',
          key: 'referenceDate',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Dias',
          key: 'delayedDays',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Status UC',
          key: 'installationStatus',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'PDF Boleto',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Data Ação',
          key: 'fieldUpdateDate',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Dia Ação',
          key: 'fieldUpdateDateDayCount',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Status Cobrança',
          key: 'judicialStatus',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Celular',
          key: 'phone',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Data à Pagar',
          key: 'dateToPaid',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Cobrador',
          key: 'responsible',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'CS',
          key: 'accountManagerName',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Observação',
          key: 'observation',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Serasa',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Protesto',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Ação Monit.',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Not. Amig.',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Not. ExtraJ.',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Enviar Fatura',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Ação',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Promotor',
          key: 'nameTrader',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Economia',
          key: 'consumerEconomy',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Cons. Total',
          key: 'totalConsumption',
          columnType: '(kWh)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Ene. Comp.',
          key: 'compensatedEnergy',
          columnType: '(kWh)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Saldo Ac.',
          key: 'accumulatedBalance',
          columnType: '(kWh)',
          sort: true,
          somatory: true,
        },
        {
          name: 'CPF/CNPJ',
          key: 'socialNumber',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Distribuidora',
          key: 'distributorName',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'UF',
          key: 'state',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Cidade',
          key: 'city',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Endereço',
          key: 'address',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'CEP',
          key: 'zipCode',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Email',
          key: 'email',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Data de Cadastro',
          key: 'userCreatedAt',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Cod Boleto',
          key: 'linhaDigitavel',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Cod 365',
          key: 'erpId',
          columnType: '',
          sort: false,
          somatory: false,
        },
      ],
      currentColumnFiltered: '',
      sortDirection: 'ASC',
      busyButton: false,
      busy: false,
    };
  },
  beforeMount: async function() {
    this.userData = await Auth.getSessionData();
  },
  methods: {
    /**
     * @param {string} columnKey
     * @return {function(): void}
     */
    sortListByKey(columnKey) {
      this.sortDirection = defineArrowDirection(
        this.currentColumnFiltered,
        columnKey,
        this.sortDirection,
      );
      this.currentColumnFiltered = columnKey;
      sortByProperty(this.list, columnKey, this.sortDirection);
    },
    /**
     * @param {string} delayedDays
     * @return {function(): string}
     */
    setColor(delayedDays) {
      return setDelayedDaysColor(delayedDays);
    },
    /**
     * @param {string} fieldUpdateDateDayCount
     * @return {function(): string}
     */
    setDayCountColor(fieldUpdateDateDayCount) {
      const daysColorMapper = [
        { maxDays: 9, color: 'color: #177178;' },
        { maxDays: 15, color: 'color: blue; font-weight: 700;' },
        { maxDays: 30, color: 'color: red; font-weight: 700;' },
        { maxDays: Infinity, color: 'color: purple; font-weight: 700;' },
      ];
      const { color } = daysColorMapper.find(
        ({ maxDays }) => fieldUpdateDateDayCount <= maxDays,
      );
      return color;
    },
    /**
     * Altera o status judicial de uma fatura e emite o evento correspondente.
     *
     * @param {Object} input - Os dados de entrada para mudar o status judicial.
     * @param {string} input.id - O ID da fatura.
     * @param {string} input.judicialStatus - O novo status judicial a ser definido para a fatura.
     * @returns {Promise<void>} Uma promessa que resolve quando a operação estiver completa.
     */
    async changeInvoiceJudicialStatus(input) {
      await this.recordTicketCollector(input.id);
      switch (input.judicialStatus) {
        case JUDICIAL_STATUS.REGISTERED_CAUSES:
          await this.$emit('sendInvoiceToSmallClaims', input.id);
          break;
        case JUDICIAL_STATUS.REGISTERED_SERASA:
          await this.$emit('sendInvoiceToSerasa', input.id);
          break;
        case JUDICIAL_STATUS.PROTEST:
          await this.$emit('sendInvoiceToProtest', input.id);
          break;
        default:
          await this.$emit('changeInvoiceToAnotherJudicialTable', {
            judicialStatus: input.judicialStatus,
            id: input.id,
          });
          break;
      }
    },
    async recordObservation(overdueInvoice) {
      try {
        this.busyButton = true;
        const httpResponse = await API.post('/execute', {
          path: `/consumer-bill-item/observation/${overdueInvoice.id}`,
          method: 'post',
          data: {
            observation: overdueInvoice.observation,
            responsible: this.userData.name,
            fieldUpdateDate: overdueInvoice.fieldUpdateDate,
          },
        });
        if (!httpResponse.ok) {
          throw new Error(
            'Não foi possível adicionar o campo observação para a fatura do id: ',
            overdueInvoice.id,
          );
        }
        this.busyButton = false;
        this.$toast.success('Observação incluída com sucesso');
      } catch (ex) {
        this.busyButton = false;
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async setIsSentToSerasa(flag, id) {
      await this.recordTicketCollector(id);
      /** @type {{ok: boolean, errors: Object}} */
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/set-is-sent-to-serasa/${id}`,
        method: 'post',
        data: { isSentToSerasa: flag },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
    },
    async setIsSentToProtest(flag, id) {
      await this.recordTicketCollector(id);
      /** @type {{ok: boolean, errors: Object}} */
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/set-is-sent-to-protest/${id}`,
        method: 'post',
        data: { isSentToProtest: flag },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
    },
    async setIsSentToSmallClaims(flag, id) {
      await this.recordTicketCollector(id);
      /** @type {{ok: boolean, errors: Object}} */
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/set-is-sent-to-small-claims/${id}`,
        method: 'post',
        data: { isSentToSmallClaims: flag },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
    },
    async setIsSentToFriendlyNotify(flag, id) {
      await this.recordTicketCollector(id);
      /** @type {{ok: boolean, errors: Object}} */
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/set-is-sent-to-friendly-notify/${id}`,
        method: 'post',
        data: { isSentToFriendlyNotify: flag },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
    },
    async setIsSentToExtrajudicial(flag, id) {
      await this.recordTicketCollector(id);
      /** @type {{ok: boolean, errors: Object}} */
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/set-is-sent-to-extrajudicial/${id}`,
        method: 'post',
        data: { isSentToExtrajudicial: flag },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
    },
    async setDateToPaid(dateToPaid, id) {
      await this.recordTicketCollector(id);
      /** @type {{ok: boolean, errors: Object}} */
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/set-date-to-paid/${id}`,
        method: 'post',
        data: { dateToPaid },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
      this.$bvToast.toast('Data a pagar registrada com sucesso!', {
        title: `Sucesso`,
        variant: 'success',
        solid: true,
      });
    },
    removeOverdueInvoiceToList(id) {
      console.log('Remover logicamente!', id);
    },
    async recordTicketCollector(id) {
      /** @type {{ok: boolean, errors: Object}} */
      await API.post('/execute', {
        path: `/invoice/record-ticket-collector/${id}`,
        method: 'post',
        data: { responsible: this.userData.name },
      });
    },
    setInvoiceInBatch(checked, id) {
      if (!this.selectInvoiceInBatch.length) {
        this.selectInvoiceInBatch.push(id);
        return;
      }

      if (checked === false) {
        this.selectInvoiceInBatch = this.selectInvoiceInBatch.filter(
          item => item !== id,
        );
        return;
      }

      this.selectInvoiceInBatch.push(id);
    },
    async setJudicialStatusInBatch() {
      this.busy = true;
      /** @type {{ok: boolean, errors: Object}} */
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/record-judicial-status-in-batch`,
        method: 'post',
        data: {
          list: this.selectInvoiceInBatch,
          name: this.userData.name,
          judicialStatus: this.judicialStatusInBatch,
        },
      });

      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        this.busy = false;
        return;
      }

      this.busy = false;
      this.$bvToast.toast(
        'Status da cobrança em lote atualizada com sucesso!',
        {
          title: `Sucesso`,
          variant: 'success',
          solid: true,
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.overdue-invoice-table {
  display: block;
  max-height: 48vh !important;
  height: auto !important;

  th:first-child,
  td:first-child {
    z-index: 2;
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    z-index: 2;
    position: sticky;
    left: 5.5rem;
    background-color: #e7e7e7;
  }

  td:nth-child(3),
  th:nth-child(3) {
    z-index: 2;
    position: sticky;
    left: 11rem;
    background-color: #e7e7e7;
  }

  td:nth-child(4),
  th:nth-child(4) {
    z-index: 2;
    position: sticky;
    left: 28rem;
    background-color: #e7e7e7;
  }

  td:nth-child(5),
  th:nth-child(5) {
    z-index: 2;
    position: sticky;
    left: 34rem;
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td:nth-child(-n + 5) {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td:nth-child(-n + 5) {
    background-color: #f2f2f2;
  }
}
</style>
